// fin-core / result — the one way a read fails across the port seam. Nothing throws over it.
//
// `forbidden` is its own kind on purpose: a missing right must never be shown as an empty
// answer (« aucun client », « aucune écriture »). The screen renders it as « Droit manquant ».

export type FinErrorKind = 'forbidden' | 'invalid' | 'transient' | 'unknown';

export interface FinError {
  readonly kind: FinErrorKind;
  readonly message: string;
  readonly retryable: boolean;
}

export type Result<T> = { readonly ok: true; readonly value: T } | { readonly ok: false; readonly error: FinError };

export const ok = <T>(value: T): Result<T> => ({ ok: true, value });

export const err = (kind: FinErrorKind, message: string, retryable = kind === 'transient'): Result<never> => ({
  ok: false,
  error: { kind, message, retryable },
});
